<template>
  <g
    :transform="(flip === true ? `scale(-.85 .85) translate(-${x/.85} ${y/.85 + 10}) rotate(-90)` : `scale(.85 .85) translate(${x/.85} ${y/.85 + 10}) rotate(-90)`)"
    stroke="white"
  >
    <rect x="0" y="0" width="15" height="61" fill="white"/>
    <rect :fill="color"  x="0.9055" y="37.5" width="19" height="13"/>
    <path
      :fill="color"
      d="M16,6.5H5a2.0059,2.0059,0,0,0-2,2v29H18V8.5A2.0059,2.0059,0,0,0,16,6.5Z"
    />
    <path fill="#e0e0e0" d="M10.5.5A2.5,2.5,0,0,0,8,3V6.5h5V3A2.5,2.5,0,0,0,10.5.5Z"/>
    <rect :fill="color" x="5.5" y="11.5" width="10" height="13"/>
    <polygon
      :fill="color"
      points="15.5 32.5 15.5 24.5 5.5 24.5 5.5 32.5 3 35.5 3 37.5 18 37.5 18 35.5 15.5 32.5"
    />
    <path
      fill="#d2d2d2"
      d="M 17,50.5 H 4 v 15 h 13 z"
    />
    <rect :fill="color" x="6.5" y="30.5" width="8" height="26"/>
  </g>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'LCPlug',
  props: {
    plugColor: String,
    x: Number,
    y: Number,
    flip: Boolean,
    clip: Boolean
  },
  data() {
    return {
      plugWidth: 30,
      plugHeight: 10
    };
  },
  computed: {
    color () {
      return this.getColor(this.plugColor)
    },
    yRecalculated () {
      return this.y - this.plugHeight / 2
    },
    ...mapGetters([
      'getCssColor'
    ])
  },
  methods: {
    getColor (colorName) { return this.getCssColor(colorName) },
    getNoseColor (colorName) { return this.getCssColor(colorName + "Nase") }
  }
}
</script>